module.exports = __webpack_public_path__ + "static/img/yjxy.18ebace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yjxy.jpg
// module id = VkPr
// module chunks = 0